import React from "react";
import Data from "./Data";

const Description = ({ Project }) => {
  return (
    <div>
      <Data Project={Project} />
    </div>
  );
};

export default Description;
